
import React, { PureComponent } from 'react'
import { Modal, Col, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import InputMoney from '../../commons/form/InputMoney'
import InputPercentage from '../../commons/form/InputPercentage'
import InputCheckBox from '../../commons/form/InputCheckBox'
import InputDatePicker from '../../commons/form/InputDatePicker'
import InputSelect from '../../commons/form/InputSelect'
import { handleKeyDown } from '../../../util/utils'

class CampaignMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      campaingGroupDisabled: true,
      campaingTypeDisabled: true,
      amountDisabled: false,
      amountPercentageDisabled: false,
      amount: false,
      amountBrand: false,
      amountPercentage: false,
      amountBrandPercentage: false,
      checkboxAmount: false,
      checkboxPercentage: false
    }
  }

  submitCampaign (values) {
    const body = {
      ...values
    }
    this.props.actions.submitCampaignDetail(body)
  }

  componentDidMount () {
    this.props.actions.fetchCampaignClass()
    this.props.actions.fecthFamily()
    this.props.actions.fetchExternalCode()
  }

  componentDidUpdate (prevProps) {
    if (this.props.showModal !== prevProps.showModal && this.props.showModal === true) {
      this.setState({ amountDisabled: false, amountPercentageDisabled: false })
      this.props.initialize(this.props.campaign)
      if (this.props.campaign) {
        this.checkComboBoxFree(this.props)
        if (this.props.campaign.amountCampaign || this.props.campaign.amountBrand) {
          this.setState({ amountPercentageDisabled: true, amount: true, amountBrand: true })
        }
        if (this.props.campaign.percentageCampaign || this.props.campaign.percentageBrand) {
          this.setState({ amountDisabled: true, amountPercentage: true, amountBrandPercentage: true })
        }
        if (this.props.campaign.campaignClassId) {
          this.props.actions.fetchCampaignGroup(this.props.campaign.campaignClassId)
        }
        if (this.props.campaign.amountFree || this.props.campaign.percentageFree) {
          this.setState({ amountDisabled: true, amountPercentageDisabled: true })
        }
        if (this.props.campaign.campaignGroupId) {
          this.props.actions.fetchCampaignTypeByGroup(this.props.campaign.campaignGroupId)
        }
      }
    }
  }

  handleCampaignClass (value) {
    if (value) {
      this.setState({ campaingGroupDisabled: false })
      this.props.actions.fetchCampaignGroup(value)
    } else {
      this.props.change('campaignGroupId', null)
      this.setState({ campaingGroupDisabled: true })
    }
  }

  handleCampaignGroup (value) {
    if (value) {
      this.setState({ campaingTypeDisabled: false })
      this.props.actions.fetchCampaignTypeByGroup(value)
    } else {
      this.props.change('campaignTypeId', null)
      this.setState({ campaingTypeDisabled: true })
    }
  }

  handleAmountFree (value) {
    this.setState({ amountPercentage: false, amountBrandPercentage: false, amount: false, amountBrand: false })
    if (value) {
      this.setState({ amountDisabled: true, amountPercentageDisabled: true, checkboxPercentage: true })
      this.props.change('amountCampaign', null)
      this.props.change('percentageCampaign', null)
      this.props.change('percentageBrand', null)
      this.props.change('amountBrand', null)
    } else {
      this.setState({ amountDisabled: false, amountPercentageDisabled: false, checkboxPercentage: false })
    }
  }

  handlePercentageFree (value) {
    this.setState({ amountPercentage: false, amountBrandPercentage: false, amount: false, amountBrand: false })
    if (value) {
      this.setState({ amountDisabled: true, amountPercentageDisabled: true, checkboxAmount: true })
      this.props.change('amountCampaign', null)
      this.props.change('percentageCampaign', null)
      this.props.change('percentageBrand', null)
      this.props.change('amountBrand', null)
    } else {
      this.setState({ amountDisabled: false, amountPercentageDisabled: false, checkboxAmount: false })
    }
  }

  checkComboBoxFree (props) {
    if (props.campaign.amountFree) {
      this.setState({ checkboxAmount: false, checkboxPercentage: true })
    } else if (props.campaign.percentageFree) {
      this.setState({ checkboxAmount: true, checkboxPercentage: false })
    }
  }

  handleAmount (value, field) {
    if (value) {
      this.setState({ amountPercentageDisabled: true, [field]: true })
    } else {
      this.setState({ [field]: false }, () => {
        if (!this.state.amount && !this.state.amountBrand) {
          this.setState({ amountPercentageDisabled: false })
        }
      })
    }
  }

  handleAmountPercentage (value, field) {
    if (value) {
      this.setState({ amountDisabled: true, [field]: true })
    } else {
      this.setState({ [field]: false }, () => {
        if (!this.state.amountPercentage && !this.state.amountBrandPercentage) {
          this.setState({ amountDisabled: false })
        }
      })
    }
  }

  render () {
    const {
      t, handleSubmit,
      showModal, nonEditable,
      combos: { campaignGroup, campaignClass, campaignType, familyCombo, externalCode }
    } = this.props
    const tKey = 'MASTERS.CAMPAIGN_DETAILS_MASTERS.MODAL.'
    return (
      <Modal id="campaingMasterModal" className="_nf" show={showModal} onHide={this.props.actions.closeCampaignMasterModal}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitCampaign.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.closeCampaignMasterModal}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="campaignClassId"
                controlLabel={t(`${tKey}CLASS`)}
                placeholder={t(`${tKey}CLASS`)}
                valueKey="id"
                labelKey="value"
                options={campaignClass}
                onChange={(value) => this.handleCampaignClass(value)}
                disabled={nonEditable}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="campaignGroupId"
                controlLabel={t(`${tKey}GROUP`)}
                placeholder={t(`${tKey}GROUP`)}
                valueKey="id"
                labelKey="value"
                options={campaignGroup}
                disabled={this.state.campaingGroupDisabled || nonEditable}
                onChange={(value) => this.handleCampaignGroup(value)}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="campaignTypeId"
                controlLabel={t(`${tKey}TYPE`)}
                placeholder={t(`${tKey}TYPE`)}
                valueKey="id"
                labelKey="value"
                options={campaignType}
                disabled={this.state.campaingTypeDisabled || nonEditable}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="campaignDetailsCode"
                controlLabel={t(`${tKey}CODE`)}
                placeholder={t(`${tKey}CODE`)}
                disabled={true}
              />
              <Field
                component={InputText}
                colWidth={66} // 25, 33, 50, 75, 100 default=25
                name="description"
                controlLabel={t(`${tKey}DESCRIPTION`)}
                placeholder={t(`${tKey}DESCRIPTION`)}
              />
              <Field
                component={InputDatePicker}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="startDate"
                controlLabel={t(`${tKey}STARTDATE`)}
                placeholder={t(`${tKey}STARTDATE`)}
              />
              <Field
                component={InputDatePicker}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="endDate"
                controlLabel={t(`${tKey}ENDDATE`)}
                placeholder={t(`${tKey}ENDDATE`)}
              />
              <Field
                component={InputMoney}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="amountCampaign"
                controlLabel={t(`${tKey}AMOUNT_CAMPAIGN`)}
                placeholder={t(`${tKey}AMOUNT_CAMPAIGN`)}
                disabled={this.state.amountDisabled}
                onChange={(value) => this.handleAmount(value.nativeEvent.data, 'amount') }
              />
              <Field
                component={InputPercentage}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="percentageCampaign"
                controlLabel={t(`${tKey}PERCENTAGE_CAMPAIGN`)}
                placeholder={t(`${tKey}PERCENTAGE_CAMPAIGN`)}
                disabled={this.state.amountPercentageDisabled}
                onChange={(value) => this.handleAmountPercentage(value.nativeEvent.data, 'amountPercentage') }
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="externalCode"
                options={externalCode}
                valueKey="campaignExternalCodeId"
                labelKey="code"
                controlLabel={t(`${tKey}EXTERNALCODE`)}
                placeholder={t(`${tKey}EXTERNALCODE`)}
              />
              <Field
                component={InputMoney}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="amountBrand"
                controlLabel={t(`${tKey}AMOUNT_BRAND`)}
                placeholder={t(`${tKey}AMOUNT_BRAND`)}
                disabled={this.state.amountDisabled}
                onChange={(value) => this.handleAmount(value.nativeEvent.data, 'amountBrand') }
              />
              <Field
                component={InputPercentage}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="percentageBrand"
                controlLabel={t(`${tKey}PERCENTAGE_BRAND`)}
                placeholder={t(`${tKey}PERCENTAGE_BRAND`)}
                disabled={this.state.amountPercentageDisabled}
                onChange={(value) => this.handleAmountPercentage(value.nativeEvent.data, 'amountBrandPercentage') }
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="gama"
                options={familyCombo}
                valueKey="familyId"
                labelKey="name"
                controlLabel={t(`${tKey}GAMA`)}
                placeholder={t(`${tKey}GAMA`)}
              />
              <Field
                component={InputText}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                name="bonified"
                controlLabel={t(`${tKey}BONIFIED`)}
                placeholder={t(`${tKey}BONIFIED`)}
              />
              <Field
                component={InputText}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                name="observations"
                controlLabel={t(`${tKey}OBSERVATIONS`)}
                placeholder={t(`${tKey}OBSERVATIONS`)}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="approvalRequired"
                controlLabel={t(`${tKey}APPROVAL_REQUIRED`)}
                placeholder={t(`${tKey}APPROVAL_REQUIRED`)}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="amountFree"
                controlLabel={t(`${tKey}FREE_AMOUNT`)}
                placeholder={t(`${tKey}FREE_AMOUNT`)}
                disabled = {this.state.checkboxAmount}
                onChange={(value) => this.handleAmountFree(value)}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="percentageFree"
                controlLabel={t(`${tKey}FREE_PERCENTAGE`)}
                placeholder={t(`${tKey}FREE_PERCENTAGE`)}
                disabled = {this.state.checkboxPercentage}
                onChange={(value) => this.handlePercentageFree(value)}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="active"
                controlLabel={t(`${tKey}ACTIVE`)}
                placeholder={t(`${tKey}ACTIVE`)}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="visible"
                controlLabel={t(`${tKey}VISIBLE`)}
                placeholder={t(`${tKey}VISIBLE`)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SUBMIT_BUTTON`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editCampaign',
  validate: (values, props) => {
    const error = { agency: {} }
    if (values) {
      const tKey = 'MASTERS.CAMPAIGN_DETAILS_MASTERS.VALIDATION.'
      if (!values.campaignClassId) {
        error.campaignClassId = props.t(`${tKey}CLASS`)
      }
      if (!values.campaignGroupId || values.campaignGroupId === null || values.campaignGroupId === -1) {
        error.campaignGroupId = props.t(`${tKey}GROUP`)
      }
      if (!values.campaignTypeId || values.campaignTypeId === null || values.campaignTypeId === -1) {
        error.campaignTypeId = props.t(`${tKey}TYPE`)
      }
      if (!values.startDate) {
        error.startDate = props.t(`${tKey}STARTDATE`)
      }
      if (!values.endDate) {
        error.endDate = props.t(`${tKey}ENDDATE`)
      }
      if (!values.amountFree && !values.percentageFree) {
        if (!values.amountCampaign && !values.amountCampaign && !values.percentageCampaign && !values.percentageBrand) {
          error.percentageCampaign = props.t(`${tKey}PERCENTAGE_CAMPAIGN`)
          error.amountCampaign = props.t(`${tKey}AMOUNT_CAMPAIGN`)
          error.amountBrand = props.t(`${tKey}AMOUNT_BRAND`)
          error.percentageBrand = props.t(`${tKey}PERCENTAGE_BRAND`)
        }
        if (values.amountCampaign || values.amountCampaign) {
          if (!values.amountCampaign) {
            error.amountCampaign = props.t(`${tKey}AMOUNT_CAMPAIGN`)
          }
          if (values.amountCampaign < 0) {
            error.amountCampaign = props.t(`${tKey}AMOUNT_CAMPAIGN_ZERO`)
          }
          if (!values.amountBrand || values.amountCampaign < 0) {
            error.amountBrand = props.t(`${tKey}AMOUNT_BRAND`)
          }
          if (values.amountBrand < 0) {
            error.amountBrand = props.t(`${tKey}AMOUNT_BRAND_ZERO`)
          }
          if (parseFloat(values.amountBrand) > parseFloat(values.amountCampaign)) {
            error.amountBrand = props.t(`${tKey}AMOUNT_BIGGER_THAN_CAMPAIGN`)
          }
        } else {
          if (!values.percentageCampaign) {
            error.percentageCampaign = props.t(`${tKey}PERCENTAGE_CAMPAIGN`)
          }
          if (!values.percentageBrand) {
            error.percentageBrand = props.t(`${tKey}PERCENTAGE_BRAND`)
          }
          if (values.percentageCampaign > 100 || values.percentageCampaign < 0) {
            error.percentageCampaign = props.t(`${tKey}PERCENTAGE_CAMPAIGN_VALUE`)
          }
          if (values.percentageBrand > 100 || values.percentageBrand < 0) {
            error.percentageBrand = props.t(`${tKey}PERCENTAGE_BRAND_VALUE`)
          }
          if (parseFloat(values.percentageBrand) > parseFloat(values.percentageCampaign)) {
            error.percentageBrand = props.t(`${tKey}PERCENTAGE_BIGGER_THAN_CAMPAIGN`)
          }
        }
      }
      if (!values.bonified) {
        error.bonified = props.t(`${tKey}BONIFIED`)
      }
      if (!values.gama) {
        error.gama = props.t(`${tKey}GAMA`)
      }
      if (!values.description) {
        error.description = props.t(`${tKey}DESCRIPTION`)
      }
      if (!values.externalCode) {
        error.externalCode = props.t(`${tKey}EXTERNALCODE`)
      }
    }
    return Object.keys(error).length > 0 ? error : {}
  }
})(CampaignMasterModal)
